// extracted by mini-css-extract-plugin
export default {"content_container":"blogid_content_container__ZE3Y4","content_quill":"blogid_content_quill__IL0O2","blog_title":"blogid_blog_title__ln7j8"};